var render, staticRenderFns
import script from "./Threes.vue?vue&type=script&lang=js&"
export * from "./Threes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Threes.vue"
export default component.exports